import languages from "./app-languages";
import tokensFromCookie from "./token-from-cookie";

//cookie is using 3 character language codes because that's what the lds header-footer deals with.
//we have ours in 2 character language codes so we convert that when we get the cookie.
const cookieKey = "language";
const determineLanguage = (threeDigitCode = false) => {
  let lang3 = "eng";
  try {
    const data = tokensFromCookie([cookieKey]);
    lang3 = data[cookieKey] || "eng";
  } catch (e) {
    lang3 = "eng";
  }

  const match = languages.find((l) => l.code3 === lang3);

  if (!match) {
    //should never happen really
    return threeDigitCode ? lang3 : "en";
  }

  return threeDigitCode ? match.code3 : match.code;
};

//get code3 so the header-footer sees our language choice
const setLanguageCookie = (language) => {
  const match = languages.find((l) => l.code === language);
  const lang3 = match?.code3 ?? "eng";
  document.cookie = `${cookieKey}=${lang3}`;

}

export {setLanguageCookie, determineLanguage}

export default determineLanguage;
